import * as React from "react";
import { SVGProps } from "react";

const KarmaEos = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 43 34"
    {...props}
  >
    <defs>
      <linearGradient
        id="a"
        x1={11.98}
        x2={31.73}
        y1={20.11}
        y2={20.11}
        gradientTransform="matrix(1 0 0 -1 0 37.25)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#29dce8" />
        <stop offset={1} stopColor="#29dc93" />
      </linearGradient>
      <linearGradient
        xlinkHref="#a"
        id="b"
        x1={16.99}
        x2={17.25}
        y1={34.1}
        y2={34.1}
      />
      <linearGradient
        xlinkHref="#a"
        id="c"
        x1={0.14}
        x2={15.71}
        y1={23.85}
        y2={23.85}
      />
      <linearGradient
        xlinkHref="#a"
        id="d"
        x1={27.91}
        x2={43.78}
        y1={23.8}
        y2={23.8}
      />
      <linearGradient
        xlinkHref="#a"
        id="e"
        x1={26.28}
        x2={26.28}
        y1={12.23}
        y2={12.23}
      />
    </defs>
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          fill="url(#a)"
          d="M22.48.11s4.5 1.8 8.4 10.7a22.27 22.27 0 0 1 .9 4.8s.2 5.9-4.1 7.7a2.38 2.38 0 0 0-1.7 2.6c.2 2.1.6 5.4.6 6.1a2.35 2.35 0 0 1-2.3 2.1 15.91 15.91 0 0 1-4.5 0c-1.5-.4-1.7-1.2-1.7-1.2s-.7-1-.2-5.4c0 0 1-3.1-1.9-4.3s-3.9-6.5-3.9-6.5-.9-5.2 4.7-12.5c0 0 3.5-4.4 5.6-4.2"
        />
        <path fill="url(#b)" d="m17.28 3-.3.3Z" />
        <path
          fill="url(#c)"
          d="M14.88 6.11a14.62 14.62 0 0 0-5.1-2.3 27.38 27.38 0 0 0-5.6-.6h-1.3a2.9 2.9 0 0 0-2.3 1 2.47 2.47 0 0 0-.5 2.2 21.18 21.18 0 0 0 5.2 11.1 25 25 0 0 0 4.7 3.9 19.81 19.81 0 0 0 5.7 2.2c-3-1.3-4-6.7-4-6.7-2.9-1.8-4.8-4.5-6.2-8.5h.1a13 13 0 0 1 7.1 2.3 16.07 16.07 0 0 1 2.2-4.6Z"
        />
        <path
          fill="url(#d)"
          d="M31.18 10.71a12.77 12.77 0 0 1 7.1-2.3h.1c-1.4 4-3.4 6.7-6.3 8.5v-.6c-.1 1.6-.7 5.9-4.2 7.4a20.74 20.74 0 0 0 6-2.3 16.07 16.07 0 0 0 4.7-3.9 22.82 22.82 0 0 0 5.2-11.1 2.47 2.47 0 0 0-.5-2.2 3.26 3.26 0 0 0-2.3-1h-1.3a26 26 0 0 0-5.6.6 13.76 13.76 0 0 0-5.2 2.4 25.33 25.33 0 0 1 2.3 4.5Z"
        />
        <path fill="url(#e)" d="M26.28 25Z" />
      </g>
    </g>
  </svg>
);

export default KarmaEos;
